import { replaceCurriculum } from 'src/store/curriculum';
import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
import dayjs from 'src/libs/dayjs';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.WeekOrSection>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => {
    return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? -1 : 1;
  },
});

const { reducer, actions } = createSlice({
  name: 'week_topic',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.WeekOrSection[]>) {
      adapter.upsertMany(state, action);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(replaceCurriculum, (state, action) => {
      const { course, sections, lessons } = action.payload.snapshot;
      adapter.removeMany(
        state,
        Object.values(state.entities)
          .filter((item) => item?.class_id === course.id)
          .map((item) => item!.id),
      );
      adapter.upsertMany(
        state,
        sections.map((section) => ({
          ...section,
          class_topics: lessons.filter(
            (lesson) => lesson.week_topic_id === section.id,
          ),
        })),
      );
    });
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.week_topic,
);

export const weekSelectorByClassId = createSelector(
  (state: RootState) => selector.selectAll(state),
  (state: RootState, class_id: number | string | undefined) => class_id,
  (week_topic, class_id) => {
    if (!class_id) return [];

    return week_topic.filter((week) => week?.class_id === class_id);
  },
);

export { reducer };
export default actions;
